const StashedCart = require('@/lib/StashedCarts/StashedCart');
const { toString } = require('@/functions/transform');

/**
 * @constructor
 */
const OrderInProgress = function () {
    /**
     * @type {StashedCart|null}
     */
    this.stashedCart = null;

    /**
     * TODO: Move to Cart.
     *
     * Can be 'sell' or 'pay'.
     *
     * @type {string}
     */
    this.state = 'sell';
};

OrderInProgress.prototype = {
    getHydrationMap() {
        return {
            stashedCart: {
                model: StashedCart,
            },
            state: toString,
        };
    },
};

module.exports = OrderInProgress;
